export default "__VITE_ASSET__DASt9c5___"